import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RiskDisclosure from './pages/RiskDisclosure';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>Deriv Trading Guide | Start Synthetic Trading Safely</title>
        <meta 
          name="description" 
          content="Learn how to trade synthetic indices with a secure platform. Step-by-step guide for beginners to start trading safely." 
        />
        <meta 
          name="keywords" 
          content="synthetic trading, synthetic indices trading, deriv trading guide, crash boom trading, trading for beginners, online trading platform" 
        />
        
        <meta property="og:title" content="Synthetic Trading Guide | Start Safely Today" />
        <meta property="og:description" content="Learn how to trade synthetic indices step by step with a trusted platform" />
        <meta property="og:url" content="https://synthetictradinghub.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Synthetic Trading Guide | Start Safely Today" />
        <meta name="twitter:description" content="Learn synthetic trading with a step-by-step beginner guide" />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9" />
        
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Synthetic Trading Hub" />
        <meta name="language" content="English" />
      </Helmet>
      
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/risk-disclosure" element={<RiskDisclosure />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
